/**
 * @author: ritesh.dabral
 * 
 * This page includes constants for action types
 */

 export const UPDATE_WHOLE_HOTSPOT_MAP_OBJECT = 'UPDATE_WHOLE_HOTSPOT_MAP_OBJECT';
 export const UPDATE_MODAL_LIST = 'UPDATE_MODAL_LIST';
 export const SET_HOTSPOT_CLICKED_INDEX = 'SET_HOTSPOT_CLICKED_INDEX';
export const SET_INCREMENT_CLICKED = 'SET_INCREMENT_CLICKED';
export const SET_DECREMENT_CLICKED = 'SET_DECREMENT_CLICKED';
export const SET_TOGGLE_HOTSPOT_VIEW = 'SET_TOGGLE_HOTSPOT_VIEW';
export const UPDATE_HOTSPOT_DATA_INTERIOR = "UPDATE_HOTSPOT_DATA_INTERIOR";
export const SET_DROPDOWN_SELECTION = "SET_DROPDOWN_SELECTION";
export const SET_INTERIOR_HOTSPOT_INDEX = "SET_INTERIOR_HOTSPOT_INDEX";
export const SET_INCREMENT_CLICKED_INTERIOR = "SET_INCREMENT_CLICKED_INTERIOR";
export const SET_DECREMENT_CLICKED_INTERIOR = "SET_DECREMENT_CLICKED_INTERIOR";
export const SET_IS360_INDEX = "SET_IS360_INDEX";
export const SET_IS360_INT_INDEX = "SET_IS360_INT_INDEX";
export const SET_TOGGLE_INTERIOR_HOTSPOTS = "SET_TOGGLE_INTERIOR_HOTSPOTS";
export const SET_IS_360_INDEX = 'SET_IS_360_INDEX';
export const SET_IS_360_INT_INDEX = 'SET_IS_360_INT_INDEX';
export const SET_TOGGLE_INTERIOR_HOTSPOT = 'SET_TOGGLE_INTERIOR_HOTSPOT';
export const UPDATE_INTERIOR360_URL = 'UPDATE_INTERIOR360_URL';
